/**
 * @generated SignedSource<<0bdce495d6c4577d6592438317c93ef1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalTimer_viewer$data = {
  readonly actualPersonId: string | null;
  readonly timerStartDate: string | null;
  readonly timerEndDate: string | null;
  readonly timerTask: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "TimeRegistrationModalTimer_viewer";
};
export type TimeRegistrationModalTimer_viewer$key = {
  readonly " $data"?: TimeRegistrationModalTimer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeRegistrationModalTimer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalTimer_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerEndDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "timerTask",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "56433041a4a684d3d293757c55d1696e";

export default node;
